export default __webpack_public_path__ + "static/media/coin_flip_decision_4.cfc10347.png";